import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {isEmpty} from 'lodash/lang';
import {SecondaryNavigation} from 'components/Navigation';
import MessageBoard from './MessageBoard';
import {fetchMessages, setCurrentMessagePage, setCurrentMessage, clearMessagesAfterPage} from 'actions/messages';

class MessageList extends React.Component {
  static propTypes = {
    messagePages: PropTypes.object.isRequired,
  };

  render() {
    const {
      schoolId,
      user,
      messagePages,
      fetchMessages,
      setCurrentMessagePage,
      setCurrentMessage,
      clearMessagesAfterPage,
      match: {
        params: {type},
      },
    } = this.props;
    return (
      <React.Fragment>
        {!['parent', 'reader'].includes(user.role) && (
          <SecondaryNavigation
            tabs={[
              {url: '/messages/create', label: 'Create Messages', isActive: false},
              {url: '/messages/received', label: 'Messages Received', isActive: type === 'received'},
              {url: '/messages/sent', label: 'Messages Sent', isActive: type === 'sent'},
            ]}
          />
        )}
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">{type} Messages</div>
            </h3>
            <MessageBoard
              {...{
                recordPages: messagePages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) => {
                  extraFilters = {...extraFilters, [type]: type === 'all' ? undefined : true};
                  if (schoolId) {
                    extraFilters.schoolId = schoolId;
                  }
                  return fetchMessages(q, page, perPage, sortOpts, extraFilters);
                },
                setCurrentRecordPage: setCurrentMessagePage,
                setCurrentRecord: setCurrentMessage,
                clearRecordsAfterPage: clearMessagesAfterPage,
                me: user,
              }}
            />
          </Panel>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {account, messages} = state;
  const user = account.get('user').toJS();
  const schoolId = !isEmpty(user.activeSchool) ? user.activeSchool.id : undefined;
  return {
    schoolId,
    user,
    messagePages: messages.get('messagePages').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMessages: (...args) => dispatch(fetchMessages(...args)),
  setCurrentMessagePage: (...args) => dispatch(setCurrentMessagePage(...args)),
  setCurrentMessage: (...args) => dispatch(setCurrentMessage(...args)),
  clearMessagesAfterPage: (...args) => dispatch(clearMessagesAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageList);
